document.addEventListener("DOMContentLoaded", function () {
    (function ($) {
        
    })(jQuery);
});
